<script lang="ts">
import { defineComponent } from 'vue'

import ViewBlogs from '~/vue/__fiftyfiveplus/_organisms/views/ViewBlogs.vue'
import CardJob from '~/vue/__fiftyfiveplus/_molecules/cards/CardJob.vue'

export default defineComponent({
    components: {
        'card--job': CardJob,
        'view--blogs': ViewBlogs
    }
})
</script>